import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

type LoyaltyIconProps = IconProps & {
  isFilled?: boolean;
};

export const LoyaltyIcon = ({
  isFilled = false,
  ...props
}: LoyaltyIconProps) => {
  return (
    <Icon viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M7.76801 2.07771C7.85198 1.8686 8.14802 1.86859 8.23199 2.07771L9.75189 5.86258C9.78765 5.95163 9.87123 6.01235 9.96697 6.01885L14.0363 6.29477C14.2611 6.31001 14.3526 6.59156 14.1796 6.73604L11.0497 9.35114C10.9761 9.41267 10.9441 9.51092 10.9675 9.60398L11.9626 13.5594C12.0176 13.7779 11.7781 13.9519 11.5872 13.8321L8.13293 11.6635C8.05165 11.6124 7.94835 11.6124 7.86707 11.6635L4.41276 13.8321C4.22191 13.9519 3.98241 13.7779 4.03739 13.5594L5.03245 9.60398C5.05587 9.51092 5.02394 9.41267 4.9503 9.35114L1.82035 6.73604C1.64742 6.59156 1.7389 6.31001 1.96373 6.29476L6.03303 6.01885C6.12877 6.01235 6.21235 5.95163 6.24811 5.86258L7.76801 2.07771Z"
        fill={isFilled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </Icon>
  );
};
